import simpleFetch from "../../../utils/simpleFetch";

class DataApi {
  static deleteDataItem(model, id, headers) {
    return simpleFetch("delete", `${model.path}/${id}`, { headers });
  }

  static getDataCount(model, filters, sectionType) {
    let query = { sectionType };
    if (filters) {
      query.filters = filters.join(";");
    }
    return simpleFetch("get", `${model.path}/count`, { query });
  }

  static getDataItem(model, id, query, headers, doesNotHaveId=false, overridablePath=null) {
    const fullPath = !doesNotHaveId ? `${model.path}/${id}` : `${model.path}`;
    return simpleFetch("get", overridablePath ? overridablePath : fullPath, { query, headers });
  }

  static getGraphQL(model, body, headers) {
    return simpleFetch("post", `${model.path}`, { body, headers });
  }

  static getDataList(
    model,
    offset,
    limit,
    q,
    sortBy,
    filters,
    headers,
    fields,
    sectionType,
    additionalParams = {}
  ) {
    let query = {
      limit,
      offset,
      q,
      sortBy: sortBy.join(","),
      fields,
      sectionType,
      ...additionalParams,
    };
    if (filters && filters.length > 0) {
      query.filters = filters.join(";");
    }
    return simpleFetch("get", model.path, { query, headers });
  }

  static getDataFile(model, path, filters, headers) {
    let query = {};
    if (filters.length > 0) {
      query.filters = filters.join(";");
    }
    return simpleFetch("get", `${model.path}/${path}`, { query, headers });
  }

  static getS3DataFile(model, path, query, headers) {
    return simpleFetch("get", `${model.path}`, { query, headers });
  }

  static patchDataItem(model, body, headers) {
    return simpleFetch(
      "PATCH",
      !!body[model.identifier]
        ? `${model.path}/${body[model.identifier]}`
        : model.path,
      { body, headers }
    );
  }

  static postDataFile(model, path, body, headers) {
    return simpleFetch("post", `${model.path}/${path}`, { body, headers });
  }

  static postDataItem(model, body, header, options, query) {
    return simpleFetch("post", model.path, { body, header, options, query });
  }

  static simplePost(model, body, headers) {
    return simpleFetch("post", model.path, { body, headers });
  }

  static getRelationshipItems(model, id, headers) {
    return simpleFetch("get", model.getPath(id), { headers });
  }
}

export default DataApi;



// WEBPACK FOOTER //
// ./src/utils/data/dataApi.js